/*
 * Outlook host strategy.
 * Delegates to the co-located OutlookHost class which wires up the shared
 * chat UI, agent service, and auth plus Outlook-specific behavior.
 */

import type { IHostStrategy } from "../host-strategy";

export class OutlookHostStrategy implements IHostStrategy {
  readonly hostType = "Outlook";

  async init(): Promise<void> {
    const { OutlookHost } = await import("./outlook");
    await new OutlookHost().init();
  }
}
